module.exports = __webpack_public_path__ + "img/outsourcing-company-vs-recruiting-agency.bf7a00a7.jpeg";